export const AuthStepItemType = {
  Password: 'Password',
  Text: 'Text',
  TextArea: 'TextArea',
  Select: 'Select',
  Email: 'Email',
  Url: 'Url',
  Html: 'Html',
  InfoBlock: 'InfoBlock',
  Snippet: 'Snippet'
};